/* =====================================================================
 * TSG Silk Product Hero — variant picker
 * Colour swatches (option1) + optional size buttons (option2). Matches the
 * selected [colour, size] to a variant and updates id / price / compare /
 * image / availability. No dependencies.
 * ===================================================================== */
(function () {
  function initSilkHero(root) {
    if (!root || root.dataset.silkInit === '1') return;
    root.dataset.silkInit = '1';

    var dataEl = root.querySelector('[data-silk-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput      = root.querySelector('[data-silk-id]');
    var priceEl      = root.querySelector('[data-silk-price]');
    var compareEl    = root.querySelector('[data-silk-compare]');
    var mainImage    = root.querySelector('[data-silk-main-image]');
    var cta          = root.querySelector('[data-silk-cta]');
    var ctaText      = root.querySelector('[data-silk-cta-text]');
    var colourValEl  = root.querySelector('[data-silk-colour-value]');
    var sizeValEl    = root.querySelector('[data-silk-size-value]');
    var swatches     = Array.prototype.slice.call(root.querySelectorAll('[data-silk-colour]'));
    var sizes        = Array.prototype.slice.call(root.querySelectorAll('[data-silk-size]'));

    var ctaDefault = ctaText ? ctaText.textContent : 'Add to cart';

    // Initial selection from the active markup
    var activeSwatch = root.querySelector('[data-silk-colour].is-active');
    var activeSize   = root.querySelector('[data-silk-size].is-active');
    var state = {
      colour: activeSwatch ? activeSwatch.getAttribute('data-silk-colour') : (variants[0] && variants[0].o1),
      size:   activeSize ? activeSize.getAttribute('data-silk-size') : (variants[0] && variants[0].o2)
    };

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.o1 === state.colour && (state.size == null || v.o2 === state.size)) return v;
      }
      // fall back to first variant matching just the colour
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].o1 === state.colour) return variants[j];
      }
      return variants[0];
    }

    function setActive(list, attr, value) {
      list.forEach(function (el) {
        var on = el.getAttribute(attr) === value;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function render() {
      var v = findVariant();
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;

      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }

      if (mainImage && v.img) {
        mainImage.src = v.img;
        if (mainImage.srcset) mainImage.srcset = '';
      }

      if (colourValEl) colourValEl.textContent = state.colour || '';
      if (sizeValEl)   sizeValEl.textContent = state.size || '';

      if (cta) {
        cta.disabled = !v.available;
        if (ctaText) ctaText.textContent = v.available ? ctaDefault : 'Sold out';
      }

      setActive(swatches, 'data-silk-colour', state.colour);
      if (sizes.length) setActive(sizes, 'data-silk-size', state.size);

      root.dispatchEvent(new CustomEvent('silk:variant:change', { detail: { variant: v }, bubbles: true }));
    }

    swatches.forEach(function (el) {
      el.addEventListener('click', function () {
        state.colour = el.getAttribute('data-silk-colour');
        render();
      });
    });
    sizes.forEach(function (el) {
      el.addEventListener('click', function () {
        state.size = el.getAttribute('data-silk-size');
        render();
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-silk-hero]').forEach(initSilkHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-render
  document.addEventListener('shopify:section:load', initAll);
})();
